function publicText(flag, value) {
  return flag ? value || "" : "";
}

function realtorContactName(userInfo) {
  const first = String((userInfo && userInfo.first_name) || "").trim();
  const last = String((userInfo && userInfo.last_name) || "").trim();
  return [first, last].filter(Boolean).join(" ");
}

function profileImagePresent(userInfo) {
  const image = userInfo && userInfo.user_image;
  if (!image) return false;
  if (typeof image === "string") return Boolean(image.trim());
  if (typeof image === "object") return Boolean(image.url);
  return true;
}

export function buildOwnerContactPrefill(userInfo) {
  if (!userInfo) {
    return {
      name: "",
      phone: "",
      email: "",
      profilePhone: "",
      profileEmail: "",
      hasProfileImage: false,
    };
  }
  const profilePhone = userInfo.phone_number || "";
  const profileEmail = userInfo.email || "";
  const name = realtorContactName(userInfo);
  return {
    name,
    phone: publicText(Boolean(userInfo.is_phone_public), profilePhone),
    email: publicText(Boolean(userInfo.is_email_public), profileEmail),
    profilePhone,
    profileEmail,
    hasProfileImage: profileImagePresent(userInfo),
  };
}
